<template>
    <div class="text-center">
        <v-dialog v-model="dialog" max-width="800">
            <template v-slot:activator="{ on, attrs }">
                <v-btn class="text-caption text-sm-body2" large rounded light v-bind="attrs" v-on="on">
                    {{$t("LP.covid19.title")}}
                </v-btn>
            </template>

            <v-card light style="background: #f2f2f2;">
                <!-- 閉じるボタン -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black" icon large @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>

                <v-container class="pa-5 pa-sm-6 px-lg-15">
                    <!-- ダイアログタイトル -->
                    <v-card-title class="headline text-center justify-center">
                        {{$t("LP.covid19.title")}}
                    </v-card-title>
                    <v-card-title class="justify-center text-center text-subtitle-1 font-weight-bold">
                        <p>{{$t("LP.covid19.notice")}}</p>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <p class="text-pre-wrap" v-html="$t('LP.covid19.caption')"></p>
                        <!-- チケットの詳細へリンク -->
                        <v-btn rounded dark :href="tickets_url" width="100%" max-width="400px" height="50" target="_blank" class="mt-6" @click="dialog = false" v-smooth-scroll>
                            <span class="text-sm-body-2 text-md-body-1">
                                {{$t("LP.covid19.detail")}}
                            </span>
                        </v-btn>
                    </v-card-text>
                    <v-card-title class="justify-center text-center text-subtitle-1 font-weight-bold mt-10" style="color:#333;">
                        <p>{{$t("LP.covid19.spec")}}</p>
                    </v-card-title>
                    <v-card-text class="mt-6">
                        <v-row>
                            <!-- covid19-guide1 -->
                            <v-col v-for="({thumbnail, description}, i) in $t('LP.covid19_guide1')" :key="i" cols="12" sm="6">
                                <v-row align="center">
                                    <v-col cols="4">
                                        <v-img contain max-height="80" max-width="100%" :src="thumbnail"></v-img>
                                    </v-col>
                                    <v-col cols="8">
                                        <p>{{description}}</p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-card-title class="justify-center text-subtitle-1 font-weight-bold mt-10" style="color:#333;">
                            <p>{{$t("LP.covid19.subtitle")}}</p>
                        </v-card-title>
                        <v-row>
                            <!-- covid19-guide2 -->
                            <v-col v-for="({thumbnail, description}, i) in $t('LP.covid19_guide2')" :key="i" cols="12" sm="6">
                                <v-row align="center">
                                    <v-col cols="4">
                                        <v-img contain max-height="80" max-width="100%" :src="thumbnail"></v-img>
                                    </v-col>
                                    <v-col cols="8">
                                        <p>{{description}}</p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-alert outlined class="text-center mt-6">
                            <div>新型コロナウイルス接触確認アプリCOCOAのインストール・登録へご協力ください。</div>
                        </v-alert>
                        <p class="mt-10"> {{$t("LP.covid19.closing")}}</p>
                    </v-card-text>
                </v-container>


            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {

        computed: {
            binding() {
                const binding = {}

                if (this.$vuetify.breakpoint.xsOnly) binding.row = true

                return binding
            }
        },

        data() {
            return {
                dialog: false,
                notifications: false,
                sound: true,
                widgets: false,
                tickets_url: '#tickets',
            }
        },
    }
</script>